import { BracesIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

/** Empty state for the replay Context tab when the turn has no node, variables, or tags. */
export const NoContextPanel = () => {
  const { t } = useTranslation();

  return (
    <Empty className="justify-start px-0 py-12">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <BracesIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t('try_it.context.empty_title')}</EmptyTitle>
        <EmptyDescription>{t('try_it.context.empty_subtitle')}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
